import PlaceTokens from "@/utils/constants/PlaceTokens";

export default class LinkUtils {
  static parseTokens(): Record<string, any> {
    let values: Record<string, any> = {};
    let token = document.location.hash;
    let tokenAfterColon = token.substring(token.indexOf(':') + 1);
    if (!token || !tokenAfterColon)
      return values;
    token = tokenAfterColon;
    token += PlaceTokens.PARAMETERS_SEPERATOR;
    let keyValuePairs = token.split(PlaceTokens.PARAMETERS_SEPERATOR);
    for (let keyValuePair of keyValuePairs) {
      let parts = keyValuePair.split(PlaceTokens.PAIR_SEPERATOR);
      if (parts.length !== 2) // ignore any malformed parameters
        continue;
      let key = parts[0];
      let value = "";
      if (parts.length > 1)
        value = parts[1];
      values[key] = value;
    }
    return values;
  }

  static fetchQueryToken(token: string) {
    let tokens = this.parseTokens();
    return tokens[token];
  }

  static getQueryParams(qs: string) {
    qs = qs.split('+').join(' ');

    let params: Record<string, any> = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
  }

  static requestParam(name: string, value: any) {
    if (value || value === false)
      return name + "=" + value + "&";
    return "";
  }
}
